import { render } from "./environmentFooter.vue?vue&type=template&id=7e03d195&ts=true"
import script from "./environmentFooter.ts?vue&type=script&lang=ts"
export * from "./environmentFooter.ts?vue&type=script&lang=ts"

import "./environmentFooter.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__